import React, { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

// login routing
const AuthLogin = Loadable(lazy(() => import('pages/authentication/login')));
// const AuthRegister = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/authentication/login/ForgotPassword')));
const AuthResetPassword = Loadable(lazy(() => import('pages/authentication/login/ResetPassword')));
const CheckResetPasswordMail = Loadable(lazy(() => import('pages/authentication/login/CheckResetPasswordMail')));

// ===========================|| AUTH ROUTING ||=========================== //

const LoginRoutes = {
  path: '/login',
  element: (
    <NavMotion>
      <GuestGuard>
        <MinimalLayout />
      </GuestGuard>
    </NavMotion>
  ),
  children: [
    {
      path: '/login',
      element: <AuthLogin />
    },
    // {
    //   path: '/register',
    //   element: <AuthRegister />
    // },
    {
      path: '/login/forgot-password',
      element: <AuthForgotPassword />
    },
    {
      path: '/login/check-reset-password-mail',
      element: <CheckResetPasswordMail />
    },
    {
      path: '/login/reset-password',
      element: <AuthResetPassword />
    }
  ]
};

export default LoginRoutes;
